module.exports = __webpack_public_path__ + "static/media/Qiqi.383a8bba.png";